export interface IExportabilityGroup {
     All: boolean,
     ChainStarters: boolean,
     PairedDonors: boolean
}


